import React from 'react';
import cookie from 'js-cookie';
import { connect } from 'react-redux';
import { Button, Form, Input, message } from 'antd';

import { withRouter } from 'react-router-dom';
import { actionGetProfile } from '../../../../../features/system/actions';
import { TOKEN, routes } from '../../../../../utils/constants/constant';

// import '../Login.scss';
import { getUserAffiliationInfo } from '../../../../../features/dashboard/actions';
import { signupAccount } from '../../../../../features/login/actions';

const RegisterStep3 = ({
  handleChangeStep = () => {},
  dataForm = {},
  handleChangeDataForm = () => {},
  history,
}) => {
  const onFinish = async (values) => {
    try {
      const dataDto = {
        ...dataForm,
        ...values,
      };
      delete dataDto.rePassword;
      const { data } = await signupAccount(dataDto);
      if (data.code === 200) {
        getToken(data);
      } else {
        data?.message && message.error(data?.message);
      }
    } catch (error) {}
  };

  const getToken = async (values) => {
    try {
      const { data } = await getUserAffiliationInfo({
        //eslint-disable-next-line
        ['login_token']: `${values.access_token}`,
      });
      if (data.code === 200) {
        cookie.set(TOKEN, values.access_token, { expires: 182 });
        handleChangeDataForm({});
        handleChangeStep(4);
        message.success('Đăng ký tài khoản thành công');
        history.push(`${routes.DASHBOARD}`);
        actionGetProfile();
      } else {
        data?.message && message.error(data?.message);
      }
    } catch (error) {}
  };

  const onFinishFailed = () => {};
  return (
    <>
      <Form
        colon={false}
        hideRequiredMark
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className='login-form'
      >
        <Form.Item
          name='name'
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập họ và tên',
            },
          ]}
        >
          <Input placeholder='Họ & Tên' className='input-login' />
        </Form.Item>
        <Form.Item
          name='email'
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập email',
            },
          ]}
        >
          <Input placeholder='Email' className='input-login' />
        </Form.Item>
        <Form.Item
          name='password'
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập mật khẩu',
            },
          ]}
        >
          <Input
            type='password'
            placeholder='Mật khẩu'
            className='input-login'
          />
        </Form.Item>
        <Form.Item
          name='rePassword'
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập lại mật khẩu',
            },
          ]}
        >
          <Input
            type='password'
            placeholder='Xác nhận lại mật khẩu'
            className='input-login'
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: '16px' }}>
          <Button type='primary' htmlType='submit' className='btn-login'>
            Hoàn thành
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default connect((state) => ({}), {
  actionGetProfile,
})(withRouter(RegisterStep3));
